<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0 border-bottom">
            <div class="d-flex justify-content-center align-items-center">
              <div class="col-md-12"><h6>Crear contrato general</h6></div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2 vh-50">
            <div class="container py-4">
              <form
                class="w-100 px-md-5"
                method="POST"
                id="formContrato"
                @submit.prevent="storeContratoGeneral"
              >
                <DatosGenerales />
                <DescripcionArrendamiento />
                <div class="text-center mt-3">
                  <button class="btn bg-gradient-primary btn-sm me-2" :disabled="loadingButton">
                    <span
                      class="spinner-border spinner-border-sm me-1"
                      role="status"
                      aria-hidden="true"
                      v-if="loadingButton"
                    ></span>
                    Guardar
                  </button>
                  <router-link
                    :to="{ name: 'contrato-general' }"
                    class="btn bg-gradient-danger btn-sm"
                    >Cancelar</router-link
                  >
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatosGenerales from "./DatosGenerales";
import DescripcionArrendamiento from "./DescripcionArrendamiento";
import useContratosStore from "@/store/contratos/";
import { storeToRefs } from 'pinia';

export default {
  components: {
    DatosGenerales,
    DescripcionArrendamiento,
  },
  setup() {
    const contratosStore = useContratosStore();
    const { loadingButton } = storeToRefs(contratosStore)
    const { storeContratoGeneral } = contratosStore;

    return {
      storeContratoGeneral,
      loadingButton,
    };
  },
};
</script>

<style></style>
